/** Coerces the API's stringified numbers; unparseable values become 0. */
const toNumber = (value) => Number(value !== null && value !== void 0 ? value : 0) || 0;
const toAmenities = (raw) => (raw !== null && raw !== void 0 ? raw : []).map((amenity) => {
    var _a, _b, _c, _d;
    return ({
        categoryCode: (_a = amenity.categoryCode) !== null && _a !== void 0 ? _a : '',
        code: (_b = amenity.code) !== null && _b !== void 0 ? _b : '',
        isTop: (_c = amenity.isTop) !== null && _c !== void 0 ? _c : false,
        name: (_d = amenity.name) !== null && _d !== void 0 ? _d : '',
    });
});
const toPolicies = (raw) => {
    var _a, _b, _c, _d, _e;
    const lateCheckout = raw === null || raw === void 0 ? void 0 : raw.lateCheckout;
    return {
        checkinTime: (_a = raw === null || raw === void 0 ? void 0 : raw.checkinTime) !== null && _a !== void 0 ? _a : null,
        checkoutTime: (_b = raw === null || raw === void 0 ? void 0 : raw.checkoutTime) !== null && _b !== void 0 ? _b : null,
        // The API sends null; the view treats "absent" as no late checkout.
        lateCheckout: lateCheckout
            ? {
                fee: (_c = lateCheckout.fee) !== null && _c !== void 0 ? _c : 0,
                feeType: (_d = lateCheckout.feeType) !== null && _d !== void 0 ? _d : 'flat',
                hour: (_e = lateCheckout.hour) !== null && _e !== void 0 ? _e : '',
            }
            : undefined,
    };
};
const toProperty = (raw) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return ({
        amenities: toAmenities(raw.amenities),
        bookingUrl: (_a = raw.bookingUrl) !== null && _a !== void 0 ? _a : '',
        code: (_b = raw.code) !== null && _b !== void 0 ? _b : '',
        currencyCode: (_c = raw.currencyCode) !== null && _c !== void 0 ? _c : '',
        description: (_d = raw.description) !== null && _d !== void 0 ? _d : '',
        hotelAddress: {
            city: (_f = (_e = raw.hotelAddress) === null || _e === void 0 ? void 0 : _e.city) !== null && _f !== void 0 ? _f : '',
            country: (_h = (_g = raw.hotelAddress) === null || _g === void 0 ? void 0 : _g.country) !== null && _h !== void 0 ? _h : '',
            state: (_k = (_j = raw.hotelAddress) === null || _j === void 0 ? void 0 : _j.state) !== null && _k !== void 0 ? _k : '',
        },
        // Availability joins on this id, so it must be a number on both sides.
        id: toNumber(raw.id),
        images: (_l = raw.images) !== null && _l !== void 0 ? _l : [],
        lat: toNumber(raw.lat),
        lng: toNumber(raw.lng),
        name: (_m = raw.name) !== null && _m !== void 0 ? _m : '',
        policies: toPolicies(raw.policies),
    });
};
export default class OrganizationDetail {
    constructor(serverData) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        Object.defineProperty(this, "customColors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: undefined
        });
        Object.defineProperty(this, "organizationId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "organizationName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "organizationSlug", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "properties", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        if (!(serverData === null || serverData === void 0 ? void 0 : serverData.success) || !serverData.data) {
            return;
        }
        const { data } = serverData;
        const primary = (_a = data.customColors) === null || _a === void 0 ? void 0 : _a.primary;
        this.organizationId = String((_c = (_b = data.associationId) !== null && _b !== void 0 ? _b : data.id) !== null && _c !== void 0 ? _c : '');
        this.organizationName = (_e = (_d = data.associationName) !== null && _d !== void 0 ? _d : data.name) !== null && _e !== void 0 ? _e : '';
        this.organizationSlug = (_g = (_f = data.associationSlug) !== null && _f !== void 0 ? _f : data.slug) !== null && _g !== void 0 ? _g : '';
        this.customColors = primary ? { primary } : undefined;
        this.properties = ((_h = data.properties) !== null && _h !== void 0 ? _h : []).map(toProperty);
    }
}
